import { useState, useCallback } from 'react';

const STORAGE_KEY = 'sparkapp_card_swipe_intro_shown';

/**
 * Hook to manage the one-time card swipe intro modal visibility.
 * Returns { isVisible, dismiss } — isVisible is true on first visit,
 * dismiss() hides the modal and persists the flag to localStorage.
 */
export function useCardSwipeIntroModal() {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) !== 'true';
    } catch {
      return true;
    }
  });

  const dismiss = useCallback(() => {
    setIsVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      console.warn('Failed to persist card swipe intro state:', error);
    }
  }, []);

  return { isVisible, dismiss };
}
